import React, { useState, useRef, useEffect } from "react";
import "./Header.css";
import Logo from "../../asstets/images/vcu_logo.png";
import { ChevronDownIcon } from "../../icons/reactIcons";
import { useNavigate } from "react-router-dom";
import { formatRole } from "../../utils/formatRole";

interface Props {
  setIsAuthenticated: (auth: boolean) => void;
}

const Header: React.FC<Props> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const adminDetail = localStorage.getItem("adminDetail");
  const user = adminDetail ? JSON.parse(adminDetail) : null;

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogOut = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("adminDetail");
    navigate("/login", { replace: true });
    setMenuOpen(false);
    setIsAuthenticated(false);
  };

  return (
    <header className="header">
      <div className="header-left">
        <img src={Logo} alt="Logo" className="header-logo" />
        <span className="header-title">POWER</span>
      </div>

      <div className="header-right" ref={menuRef}>
        {/* <img
          src={user?.profilePic || "/default-avatar.png"}
          alt="User Avatar"
          className="header-avatar"
        /> */}
        <div className="header-user-block">
          <div
            className="header-user-info"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="user-name">{user?.name || "Moni Roy"}</span>
            <span className="user-role">
              {formatRole(user?.role) || "Admin"}
            </span>
          </div>
          <ChevronDownIcon
            className={`header-role-arrow ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          />
          {menuOpen && (
            <div className="header-menubar">
              <ul>
                {/* <li>Profile</li> */}
                {/* <li>Settings</li> */}
                <li onClick={handleLogOut}>Logout</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
